import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../../LabelText';
import RatingInput from './Input';

const Rating = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;

	const rating = form_component.rating || {};
	const ratingLabels = Array.isArray(rating.rating_label) ? rating.rating_label : [];
	const subQuestions = Array.isArray(rating.sub_questions) ? rating.sub_questions : [];

	const fv = useSelector(state => state.fv);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required && ratingLabels.length) {
			ratingLabels.map((rating_label, index) => {
				var validator = {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					}
				};

				fv.addField(form_component.fieldname[index], validator);
			});
		}

		// Add duplicate rating validation if ban_duplicate_rating is true
		if (fv && form_component.ban_duplicate_rating && subQuestions.length) {
			subQuestions.map((sub_question, index) => {
				const fieldName = `${form_component.fieldname}[${index}]`;
				
				// Check if field already has validators (from required validation)
				const existingValidators = {};
				if (form_component.required) {
					existingValidators.notEmpty = {
						message: t('此欄為必須填寫')
					};
				}
				
				// Add duplicate rating validation
				existingValidators.callback = {
					message: t('不允許選擇相同的答案'),
					callback: function(value, validator, $field) {
						try {
							// Get all rating values for this form component
							const allValues = [];
							subQuestions.forEach((_, subIndex) => {
								const fieldNameToCheck = `${form_component.fieldname}[${subIndex}]`;
								const fieldElements = fv.getElements(fieldNameToCheck);
								
								const checkedElement = fieldElements.filter(el => el.checked)[0];
								
								if (checkedElement && checkedElement.value !== undefined && checkedElement.value !== '') {
									allValues.push(checkedElement.value);
								}
							});

							// Check for duplicates - must have at least 2 values to have duplicates
							if (allValues.length < 2) {
								return true;
							}

							const uniqueValues = [...new Set(allValues)];
							const hasDuplicates = allValues.length !== uniqueValues.length;
							
							return !hasDuplicates;
						} catch (error) {
							console.error('Error in validation callback:', error);
							return true; // Return true to avoid blocking form submission on error
						}
					}
				};
				
				var validator = {
					validators: existingValidators
				};
				
				fv.addField(fieldName, validator);
			});
		}
	}, [fv, form_component.required, form_component.ban_duplicate_rating, ratingLabels.length, subQuestions.length]);

	if (!ratingLabels.length || !subQuestions.length) {
		return null;
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<div className="sub-quest-box fixtop position-relative">
				<div className="score-level  ms-auto">
					<div className="w-200px score-level__empty p-xl-3"></div>
					<div className="score-level__scales">
						<div className="d-flex gap-2 flex-grow-1 p-3 text-gray-700">
							{(() => {
								const components = [];
								
								ratingLabels.map((rating_label, index) => {
									components.push(
										<div key={`rating-label-${index}`} className="col px-3 text-center">
											{rating_label}
										</div>
									);
								});

								return components;
							})()}
						</div>
					</div>
				</div>
				{(() => {
					const components = [];
					
					subQuestions.map((sub_question, index) => {
						if (index > 0) {
							components.push(
								<div key={`sub-question-separator-${index}`} className="my-1"></div>
							);
						}
						components.push(
							<div key={`sub-question-${index}`} className="sub-quest fixtop w-100">
								<span className="sub-quest__title  p-xl-3">{sub_question.label}</span>
								<div className="label_box label-matrix ">
									<div className="d-flex gap-2 p-xl-3 flex-column flex-xl-row flex-grow-1">
										{!form_component.required && (
											<input type="hidden" name={`${form_component.fieldname}[${index}]`} value="" />
										)}
										{(() => {
											const components2 = [];
											
											ratingLabels.map((rating_label, index2) => {
												components2.push(
													<RatingInput
														key={`rating-input-${index2}`}
														lang={props.lang}
														form_component={form_component}
														index={index}
														index2={index2}
														sub_question={sub_question}
														rating_label={rating_label}
													/>
												);
											});

											return components2;
										})()}
									</div>
								</div>
							</div>
						);
					});

					return components;
				})()}
			</div>
		</div>
	);
}

export default Rating;